<h2 mat-dialog-title>{{ data.dialog_title }}</h2>

<mat-dialog-content>
  <p class="dialog-description">{{ data.dialog_description }}</p>

  <form [formGroup]="form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Instrucciones adicionales (opcional)</mat-label>
      <textarea
        matInput
        formControlName="additional_prompt"
        rows="5"
        placeholder="Ej. Quiero evaluar claridad y profundidad técnica. En el nivel alto deben mencionar trade-offs de rendimiento..."
      ></textarea>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">{{ data.dialog_cancel_button }}</button>
  <button mat-flat-button color="accent" type="button" (click)="confirm()">{{ data.dialog_confirm_button }}</button>
</mat-dialog-actions>
